<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
			<span style="margin-right: 0.25em;">{{projectName}} - Docusign Envelopes</span>
		</span>
  </div>
  <div style="flex: 1">

  </div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="order header-order">
    <div class="checkmark-blockkk">

    </div>
    <div class="nom-block label-block">
      <div class="label-name" (click)="sortByLabel('id')" matRipple>NO.
        <i *ngIf="sortMap.get('id') === 1" class="pi pi-arrow-down"></i>
        <i *ngIf="sortMap.get('id') === 2" class="pi pi-arrow-up"></i>
      </div>
    </div>

    <div class="date-block label-block">
      <div class="label-name" (click)="sortByLabel('createdDate')" matRipple>CREATED
        <i *ngIf="sortMap.get('createdDate') === 1" class="pi pi-arrow-down"></i>
        <i *ngIf="sortMap.get('createdDate') === 2" class="pi pi-arrow-up"></i>
      </div>
    </div>
    <div class="date-block sent-block label-block">
      <div class="label-name" (click)="sortByLabel('sentDate')" matRipple>SENT
        <i *ngIf="sortMap.get('sentDate') === 1" class="pi pi-arrow-down"></i>
        <i *ngIf="sortMap.get('sentDate') === 2" class="pi pi-arrow-up"></i>
      </div>
    </div>
    <div class="balance-block label-block">
      <div class="label-name" (click)="sortByLabel('signedDate')" matRipple>SIGNED
        <i *ngIf="sortMap.get('signedDate') === 1" class="pi pi-arrow-down"></i>
        <i *ngIf="sortMap.get('signedDate') === 2" class="pi pi-arrow-up"></i>
      </div>
    </div>
    <div class="status-block label-block">
      <div class="label-name" (click)="sortByLabel('status')" matRipple>STATUS
        <i *ngIf="sortMap.get('status') === 1" class="pi pi-arrow-down"></i>
        <i *ngIf="sortMap.get('status') === 2" class="pi pi-arrow-up"></i>
      </div>
    </div>
    <div class="link-block">
    </div>
  </div>

  <div class="orders-block">
    <div class="order" *ngFor="let env of listToShow; trackBy: trackEntityById">

      <div class="checkmark-blockkk">

      </div>
      <div class="nom-block label-block">
        <div class="label-name">#{{env.id}}</div>
      </div>

      <div class="date-block label-block">
        <div class="label-name">{{env.createdDate | date: 'M/d/yy'}}</div>
      </div>
      <div class="date-block sent-block label-block">
        <div class="label-name">{{env.sentDate | date: 'M/d/yy'}}</div>
      </div>
      <div class="balance-block label-block">
        <div class="label-name">{{env.signedDate | date: 'M/d/yy'}}</div>
      </div>
      <div class="status-block label-block">
        <div class="label-name">{{env.status}}</div>
      </div>
      <div class="link-block">
        <button mat-button class="delete-envelope-button" (click)="deleteDocu(env)">
          <mat-icon *ngIf="deleteIdSpinner !== env.id">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteIdSpinner === env.id"></lib-mini-progress-spinner>
        </button>
        <button mat-button class="open-link-button" (click)="openDocu(env)">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </div>
  </div>


  <div class="spinner-box" *ngIf="contentLoading">
    <mat-spinner class="spinner"></mat-spinner>
  </div>
</div>
